import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

export type OrganizationWorkflowCreatedAction = {
	type: 'ORGANIZATION_WORKFLOW_CREATED';
	payload: OrganizationWorkflowPayload;
	organizationId: number;
};

export default (
	payload: OrganizationWorkflowPayload,
	organizationId: number,
): OrganizationWorkflowCreatedAction => ({
	type: 'ORGANIZATION_WORKFLOW_CREATED',
	payload,
	organizationId,
});
